import { gql } from '@apollo/client'

export const CREATE_CHAT = gql`
  mutation CreateChat($locationId: ID) {
    createChat(input: { locationId: $locationId }) {
      id
      locationId
    }
  }
`
